module.exports = __webpack_public_path__ + "img/sz.c348da45.svg";